import React from 'react'
import { observer, inject } from 'mobx-react'
import { selectionTypes } from '../../constants'
import { withTranslation } from 'react-i18next'

const ProcessingTargetGroupAnalysisView = ({ selectionStore, t }) => (
  <div className='analysis-container'>
    <div className='analysis loading loading-dark analysis-with-chart'>
      <div className='message-container'>
        <p>{selectionStore.type === selectionTypes.TARGET_GROUP &&
        t('GLOBAL.ANALYSING_TARGET_GROUP')}
        </p>
      </div>
      <section className='analysis-tall'>
        <div className='analysis-contents'>
          <div className='analysis-column' />
        </div>
      </section>
    </div>
  </div>
)

export default withTranslation()(inject('selectionStore')(observer(ProcessingTargetGroupAnalysisView)))
